/**
 * @krisspy-file
 * @type component
 * @name "IdeaCard"
 * @description "Draggable chip pro nápad/inspiraci s barevným designem"
 */

import React from 'react';
import { Lightbulb, GripHorizontal, Star } from 'lucide-react';

interface IdeaCardProps {
  id: string;
  title: string;
  source: 'global' | 'user';
  isDraggable?: boolean;
  onClick?: () => void;
  dragHandleProps?: Record<string, unknown>;
  isDragging?: boolean;
}

const IdeaCard: React.FC<IdeaCardProps> = ({
  id,
  title,
  source,
  isDraggable = true,
  onClick,
  dragHandleProps,
  isDragging = false,
}) => {
  const isGlobal = source === 'global';

  return (
    <div
      onClick={onClick}
      className={`
        group relative flex items-center gap-2 px-3 py-2 rounded-xl border
        text-xs font-semibold cursor-pointer select-none transition-all duration-150
        ${isGlobal
          ? 'bg-amber-50 border-amber-200 text-amber-800 hover:bg-amber-100 hover:border-amber-400'
          : 'bg-purple-50 border-purple-200 text-purple-800 hover:bg-purple-100 hover:border-purple-400'
        }
        ${isDragging ? 'shadow-lg scale-105 rotate-1 opacity-90' : 'shadow-sm hover:shadow-md'}
      `}
    >
      {/* Drag handle */}
      {isDraggable && (
        <span
          {...(dragHandleProps ?? {})}
          className="cursor-grab active:cursor-grabbing text-current opacity-30 hover:opacity-60 flex-shrink-0"
        >
          <GripHorizontal className="w-3 h-3" />
        </span>
      )}

      {/* Icon */}
      {isGlobal ? (
        <Lightbulb className="w-3 h-3 flex-shrink-0" />
      ) : (
        <Star className="w-3 h-3 flex-shrink-0" />
      )}

      {/* Title */}
      <span className="truncate max-w-[160px]">{title}</span>

      {/* Source badge */}
      <span
        className={`ml-auto flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded-full font-medium
          ${isGlobal
            ? 'bg-amber-200 text-amber-700'
            : 'bg-purple-200 text-purple-700'
          }`}
      >
        {isGlobal ? 'Globální' : 'Vlastní'}
      </span>
    </div>
  );
};

export default IdeaCard;
